export type FeeCode =
  | "blue"
  | "green"
  | "yellow"
  | "red"
  | "orange"
  | "brown"
  | "pink"
  | "white";

export type Fee =
  | "Zona A"
  | "Zona B"
  | "Zona C"
  | "Zona Azul"
  | "Zona Vermelha"
  | "Zona Branca"
  | "Zona Verde"
  | "Zona Roxa"
  | "Zona Cor de Laranja"
  | "Zona Castanha"
  | "Zona Amarela";

export const getFeeCode = (fee: string): FeeCode | undefined => {
  const map: Record<Fee, FeeCode> = {
    "Zona A": "blue",
    "Zona B": "green",
    "Zona C": "yellow",
    "Zona Azul": "blue",
    "Zona Vermelha": "red",
    "Zona Branca": "white",
    "Zona Verde": "green",
    "Zona Roxa": "pink",
    "Zona Castanha": "brown",
    "Zona Cor de Laranja": "orange",
    "Zona Amarela": "yellow",
  };

  const keys = (Object.keys(map) as Array<Fee>).filter((mapKey) => {
    return fee.includes(mapKey);
  });

  if (keys.length > 1) {
    return map[keys[keys.length - 1]]; // Match by the last found key since it is more exact
  }

  return keys[0] ? map[keys[0]] : undefined;
};
